import { IncError } from "@core/domain/errors/inc.error";
import i18n from "@i18n";

export class PartnersMapperError extends IncError {
    constructor() {
        super(i18n.t("error:entity.partners.partnersMapperError"));

        Object.setPrototypeOf(this, PartnersMapperError.prototype);
    }
}